




<mat-tab-group  mat-stretch-tabs="false" class="matTab custom-mat-tab overflow-hidden"
    (selectedIndexChange)="selectedIndexChangeNew($event)" [selectedIndex]="selectedIndexo">

    <app-loader *ngIf='isLoading' id="mater"></app-loader>

    <mat-tab label="Renewables Cost">
        <div class="matContent tabBody">
            <div class="tabInnerBody">
            <div class="row">

                <div class="col-md-8 renewableBox">

                    <mat-grid-list id="fxdtit" class="fixedTitle" cols="2" rowHeight="35px">

                       <div id="solarActText"></div>
                    </mat-grid-list>
                    <mat-grid-list class="fixedTitle " cols="5" rowHeight="35px">

                        <mat-grid-tile class="newgrid bg-color-grey">Area of PV
                            (m<sup>2</sup>)</mat-grid-tile>
                        <mat-grid-tile class="newgrid bg-color-grey">Efficiency (%)</mat-grid-tile>
                        <mat-grid-tile class="newgrid bg-color-grey">Azimuth (degrees)</mat-grid-tile>
                        <mat-grid-tile class="newgrid bg-color-grey">Inclination
                            (degrees)</mat-grid-tile>
                        <mat-grid-tile class="costcol">Cost ($/m2)</mat-grid-tile>

                    </mat-grid-list>

                    <mat-grid-list cols="5" rowHeight="50px">
                        <div *ngFor="let rewnew of rewval?.projLists">

                            <mat-grid-tile class="bg-color-white" (blur)="onBlurMethodSolar()" id="heateng"
                                attr.contenteditable="{{contentEditableRen}}">
                                {{rewnew.solar_area_of_pv}}</mat-grid-tile>
                            <mat-grid-tile class="bg-color-white" (blur)="onBlurMethodSolar()" id="solarEffi"
                                attr.contenteditable="{{contentEditableRen}}">
                                {{rewnew.solar_efficiency}}</mat-grid-tile>
                            <mat-grid-tile id="solarAzi" [ngClass]="'noedit_text'">
                                {{rewnew.solar_azimuth}}</mat-grid-tile>
                            <mat-grid-tile id="solarIncl" [ngClass]="'noedit_text'">
                                {{rewnew.solar_inclination}}</mat-grid-tile>
                            <mat-grid-tile class="bg-color-white" (blur)="getText($event,0,1500)"
                                (keydown)="getDefVal($event)" (blur)="onBlurMethodSolar()"
                                attr.contenteditable="{{ toggleStatusNew }}"><span id="solarcost"
                                    (blur)="onBlurMethodSolar()"> {{rewnew.solar_cost}}</span></mat-grid-tile>


                        </div>


                    </mat-grid-list>
                   
                </div>
            </div> <!--end of row div -->
            <div class="row">
                <div class="col-md-8 renewableBoxWp">
                    <mat-grid-list id="fxdntt" class="fixedTitle" cols="2" rowHeight="50px">

                       

                        <div id="windActText"></div>

                    </mat-grid-list>

                    <mat-grid-list class="fixedTitle " cols="4" rowHeight="35px">

                        <mat-grid-tile class="newgrid">Rated Power (kW)</mat-grid-tile>
                        <mat-grid-tile class="newgrid" [colspan]="2">Hub Height (Meter)</mat-grid-tile>
                        <mat-grid-tile class="costcol">Cost ($/kW)</mat-grid-tile>

                    </mat-grid-list>

                    <mat-grid-list cols="4" rowHeight="50px">
                        <div *ngFor="let rewnew of rewval?.projLists">

                            <mat-grid-tile (blur)="onBlurMethodWind()" id="renewKw"
                                attr.contenteditable="{{contentEditableWin}}" [ngClass]="'noedit_text'">
                                {{rewnew.wind_rated_kW}}</mat-grid-tile>
                            <mat-grid-tile id="renewHub" [colspan]="2"> {{rewnew.wind_hub_height}}</mat-grid-tile>

                            <mat-grid-tile class="bg-color-white" attr.contenteditable="{{toggleStatusNewWind}}"
                                (blur)="getText($event,0,3000)" (blur)="onBlurMethodWind()"
                                (keydown)="getDefVal($event)"><span id="windcost" (blur)="onBlurMethodWind()">
                                    {{rewnew.wind_cost}}</span></mat-grid-tile>



                        </div>


                    </mat-grid-list>
                    <div>Note:Rotor of the wind turbine assumed to be installed at peak height of the building</div>
                    
                </div>
            </div> <!--end of row div -->
           
        </div>
            <div class="buttonStep buttonStepWithoutWizard">
                <button (click)="clickMeForwar()" class="nextStepBotRenew" mat-raised-button color="primary"
                    ng-disabled="isUpdated==true">Next</button>
            </div>
        </div>
    </mat-tab>

    <mat-tab label="Design Variables Cost" [disabled]="isUpdated===true">

        <div class="matContent">


            <!-- Design Variables placeholder data<br/>
          test data for Design Variables test data for renewables test data for Design -->

            <!-- Work in progress...for this Wizard -->
            <mat-tab-group id="innerTabCost" class="matTab designvariable for-variables-screan"
                (selectedIndexChange)="NewselectedIndexChange($event)" [selectedIndex]="newselectedIndex">
                <mat-tab label="Building Envelop" [disabled]="isUpdated===true" class="bg-color-white overflow-hidden">

                    <div class="tabBody">
                        <div class="tabInnerBody">
                            <div class="row">
                                <!-- WALL -->
                                <div class="col-md-2">
                                    <div class="table-responsive wizardTableAlignments">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="width-20"></th>
                                                    <th colspan="2" class="text-center">WALL</th>
                                                </tr>

                                                <tr>
                                                    <th class="width-20"></th>
                                                    <th class="text-center">R-Value(IP)</th>
                                                    <th [ngClass]="{'editableHeaderClass': contedit === true}"
                                                        class="text-center">$/m2</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr id="wall" *ngFor="let folder of buildEnv?.projLists">
                                                    <td class="width-20" *ngIf='folder.wall_checked == "Yes"'>
                                                        <mat-checkbox class="checkbox-negative" id="wall" *ngIf='folder.wall_checked == "Yes"'
                                                            [checked]="message.includes(folder.wall_r_value_ip) && currentHideArr.indexOf('WALL') == -1"
                                                            [value]="folder.wall" (change)="checkValWall()"
                                                            [disabled]="true"
                                                            title="To edit variable selection please go to variable wizard screen"></mat-checkbox>
                                                    </td>

                                                    <!-- [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}" -->
                                                    <td *ngIf='folder.wall_checked == "Yes"'
                                                        [ngClass]="{'editableSideClass': contedit === true}"
                                                        class="col text-center width-50" id="btn-{{folder.wall}}">
                                                        {{folder.wall_r_value_ip}}
                                                    </td>
                                                    <td *ngIf='folder.wall_checked == "Yes"'
                                                        class="col text-center width-40" id="btnnew-{{folder.wall}}"
                                                        (click)="getIdfirst($event,folder.wall)"
                                                        (blur)="getText($event,0,500)" (blur)="getHvac(folder.wall)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contedit}}">{{folder.wall_cost}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- Roof -->
                                <div class="col-md-2">
                                    <div class="table-responsive wizardTableAlignments">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="width-20"></th>
                                                    <th colspan="2" class="text-center">ROOF</th>
                                                </tr>

                                                <tr>
                                                    <th class="width-20"></th>
                                                    <th class="text-center">R-Value(IP)</th>
                                                    <th [ngClass]="{'editableHeaderClass': contedit === true}"
                                                        class="text-center">$/m2</th>
                                                </tr>
                                            </thead>
                                            <tbody id="roof_cost">
                                                <tr id="roofitem" *ngFor="let folder of buildEnv?.projLists">
                                                    <td *ngIf='folder.roof_checked == "Yes"' class="width-20">
                                                        <mat-checkbox class="checkbox-negative" *ngIf='folder.roof_checked == "Yes"'
                                                            [checked]="message.includes(folder.roof_r_value_ip)  && currentHideArr.indexOf('ROOF') == -1"
                                                            [value]="folder.roof_r_value_ip" (change)="checkValRoof()"
                                                            [disabled]="true"
                                                            title="To edit variable selection please go to variable wizard screen"></mat-checkbox>
                                                    </td>
                                                    <td *ngIf='folder.roof_checked == "Yes"'
                                                        [ngClass]="{'editableSideClass': contedit === true}"
                                                        class="col text-center width-50" id="btnroof-{{folder.roof}}">
                                                        {{folder.roof_r_value_ip}}
                                                    </td>
                                                    <td *ngIf='folder.roof_checked == "Yes"'
                                                        class="col text-center width-50" id="btnroofnew-{{folder.roof}}"
                                                        (click)="getIdfirstRoof($event,folder.roof)"
                                                        (blur)="getHvacRoof(folder.roof)" (blur)="getText($event,0,500)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contedit}}">
                                                        {{folder.roof_cost}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- FLoor -->
                                <div class="col-md-2">
                                    <div class="table-responsive wizardTableAlignments">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="width-20"></th>
                                                    <th colspan="2" class="text-center">{{custName === ''? 'FLOOR' : custName}}</th>
                                                </tr>

                                                <tr>
                                                    <th class="width-20"></th>
                                                    <th class="text-center">R-Value(IP)</th>
                                                    <th [ngClass]="{'editableHeaderClass': contedit === true}"
                                                        class="text-center">$/m2</th>
                                                </tr>
                                            </thead>
                                            <tbody id="floor_cost">
                                                <tr id="flooritem" *ngFor="let folder of buildEnv?.projLists">
                                                    <td *ngIf='folder.floor_checked == "Yes"' class="width-20">
                                                        <mat-checkbox class="checkbox-negative" *ngIf='folder.floor_checked == "Yes"'
                                                            [checked]="message.includes(folder.floor_r_value_ip) &&  currentHideArr.indexOf('FLOOR') == -1"
                                                            [value]="folder.floor" (change)="checkValFloor()"
                                                            [disabled]="true"
                                                            title="To edit variable selection please go to variable wizard screen"></mat-checkbox>
                                                    </td>
                                                    <td *ngIf='folder.floor_checked == "Yes"'
                                                        [ngClass]="{'editableSideClass': contedit === true}"
                                                        class="col text-center width-50" id="btnfloor-{{folder.floor}}">
                                                        {{folder.floor_r_value_ip}}
                                                    </td>
                                                    <td *ngIf='folder.floor_checked == "Yes"'
                                                        class="col text-center width-40"
                                                        id="btnfloornew-{{folder.floor}}"
                                                        (click)="getIdfirstFloor($event,folder.floor)"
                                                        (blur)="getText($event,0,500)"
                                                        (blur)="getHvacFloor(folder.floor)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contedit}}">
                                                        {{folder.flr_cost}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- Window -->
                                <div class="col-md-4">
                                    <div class="table-responsive wizardTableAlignments">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="width-15"></th>
                                                    <th colspan="3" class="text-center">WINDOW</th>
                                                </tr>

                                                <tr>
                                                    <th class="width-15"></th>
                                                    <th class="text-center">R-Value(IP)</th>
                                                    <th class="text-center">SHGC</th>
                                                    <th [ngClass]="{'editableHeaderClass': contedit === true}"
                                                        class="text-center">$/m2</th>
                                                </tr>
                                            </thead>
                                            <tbody id="windw">
                                                <tr id="windowitem" *ngFor="let folder of buildEnv?.projLists">
                                                    <td *ngIf='folder.win_checked == "Yes"' class="width-15">
                                                        <mat-checkbox *ngIf='folder.win_checked == "Yes"'
                                                            [checked]="message.includes(folder.win_r_value_ip)  && currentHideArr.indexOf('WINDOW') == -1"
                                                            [value]="folder.windows" (change)="checkValWindow()"
                                                            [disabled]="true"
                                                            title="To edit variable selection please go to variable wizard screen"></mat-checkbox>
                                                    </td>
                                                    <td *ngIf='folder.win_checked == "Yes"' class="d-none"
                                                        id="btn-{{folder.windows}}">{{folder.windows}}</td>
                                                    <td class="col text-center width-30"
                                                        *ngIf='folder.win_checked == "Yes"'>{{folder.win_r_value_ip_ref }}
                                                    </td>
                                                    <td class="col text-center width-30"
                                                        *ngIf='folder.win_checked == "Yes"'
                                                        [ngClass]="{'editableSideClass': contedit === true}">
                                                        {{folder.win_shgc }}</td>
                                                    <td class="col text-center width-30"
                                                        *ngIf='folder.win_checked == "Yes"'
                                                        id="btnnew-{{folder.windows}}"
                                                        (click)="getIdfirstWindows(folder.windows)"
                                                        (blur)="getText($event,0,3000)"
                                                        (blur)="getHvacWindows(folder.windows)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contedit}}">{{folder.win_cost}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>


                                <!-- Shading -->
                                <div class="col-md-2">
                                    <div class="table-responsive wizardTableAlignments">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="width-20"></th>
                                                    <th colspan="2" class="text-center">Shading</th>
                                                </tr>

                                                <tr>
                                                    <th class="width-20"></th>
                                                    <th [ngClass]="{'editableHeaderClass': contedit === true}"
                                                        colspan="2" class="text-center">Lumpsum cost ($)</th>
                                                </tr>
                                            </thead>
                                            <tbody id="shading_cost">
                                                <tr id="shadingitem"
                                                    *ngFor="let folder of BuildEnvCost?.projLists | slice:0:2">
                                                    <td class="width-20">
                                                        <mat-checkbox class="checkbox-negative" [checked]="message.includes(folder.shading)  && currentHideArr.indexOf('SHADING') == -1"
                                                            [value]="folder.shading" (change)="checkValShading()"
                                                            [disabled]="true"
                                                            title="To edit variable selection please go to variable wizard screen"></mat-checkbox>
                                                    </td>

                                                    <td [ngClass]="{'editableSideClass': contedit === true}"
                                                        class="col text-center width-50" id="btn-{{folder.shading}}">
                                                        {{folder.shading}}
                                                    </td>
                                                    <td class="col text-center width-40" id="btnnew-{{folder.shading}}"
                                                        (click)="getIdfirstShading(folder.shading)"
                                                        (blur)="getText($event,0,100000)"
                                                        (blur)="getHvacShading(folder.shading)"
                                                        (keydown)="getDefVal($event)"
                                                        attr.contenteditable="{{contedit}}">{{folder.shading_cost}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <!-- Custom BaseLine -->
                        <div class="row mb-2 mt-2">
                            <div class="col-md-12">
                                <div class="d-flex align-items-center ml-1 mb-2">
                                    <mat-checkbox [checked]="newToggleEditable" [disabled]="true" class="ml-0"
                                        title="To edit variable selection please go to variable wizard screen"></mat-checkbox>
                                    <div> Create Custom Baseline - Cost values from this wizard are applicable for each
                                        of the custom baseline variables </div>

                                </div>
                            </div>
                        </div>








                        <div class="row">
                            <!-- WALL -->
                            <div class="col-md-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center" [(ngModel)]="newcustBase"
                                                        name="elegas" id="Ultra" *ngIf="newToggleEditable=='true'"
                                                        [disabled]="true"
                                                        title="To edit variable selection please go to variable wizard screen">
                                                        <option
                                                            *ngFor="let folder of BuildEnvCost?.projLists | slice:0:7"
                                                            [value]="folder.wall" selected="newcustBase">
                                                            {{folder.wall_r_value_ip}}</option>

                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>


                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="newcustBaseRoof" name="elegas" id="Ultratwo"
                                                        [disabled]="true" *ngIf="newToggleEditable=='true'"
                                                        title="To edit variable selection please go to variable wizard screen">

                                                        <option
                                                            *ngFor="let folder of BuildEnvCost?.projLists | slice:0:5"
                                                            [value]="folder.roof" selected="newcustBaseRoof">
                                                            {{folder.roof_r_value_ip}}</option>

                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>


                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="newcustBaseFloor" name="elegas" id="Ultrathree"
                                                        [disabled]="true" *ngIf="newToggleEditable=='true'"
                                                        title="To edit variable selection please go to variable wizard screen">
                                                        <option
                                                            *ngFor="let folder of BuildEnvCost?.projLists | slice:0:3"
                                                            [value]="folder.floor" selected="newcustBaseFloor">
                                                            {{folder.floor_r_value_ip}}
                                                        </option>

                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>


                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="newcustBaseWindow" name="elegas" id="UltraFour"
                                                        [disabled]="true" *ngIf="newToggleEditable=='true'"
                                                        title="To edit variable selection please go to variable wizard screen">

                                                        <option
                                                            *ngFor="let folder of BuildEnvCost?.projLists | slice:0:12"
                                                            [value]="folder.windows" selected="newcustBaseWindow">
                                                            {{folder.win_r_value_ip}}</option>

                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>


                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="newcustBaseShading" name="elegas" id="UltraFive"
                                                        [disabled]="true" *ngIf="newToggleEditable=='true'"
                                                        title="To edit variable selection please go to variable wizard screen">
                                                        <option
                                                            *ngFor="let folder of BuildEnvCost?.projLists | slice:0:2"
                                                            [value]="folder.shading" selected="newcustBaseShading">
                                                            {{folder.shading}}</option>

                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>


                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="table-responsive wizardTableAlignments">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="newcustBaseWwr" name="elegas" id="UltraSix"
                                                        [disabled]="true" (change)="CustBaseWwr()"
                                                        *ngIf="newToggleEditable=='true'"
                                                        title="To edit variable selection please go to variable wizard screen">

                                                        <option
                                                            *ngFor="let folder of BuildEnvCost?.projLists | slice:0:3"
                                                            [value]="folder.wwr_percentage" selected="newcustBaseWwr">
                                                            {{folder.wwr_percentage}}
                                                        </option>

                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>


                                </div>
                            </div>
                        </div>


                        <div class="d-flex solar-cutomline">
                            <div id="solarText" *ngIf="toggleStatusNew=='true'? true:false">Solar PV - Turned ON</div>
                            <div id="solarText" *ngIf="toggleStatusNew=='false'? true:false">Solar PV - Turned OFF</div>
                            <div id="windText" *ngIf="toggleStatusNewWind=='true'? true:false">Wind Power - Turned ON
                            </div>
                            <div id="windText" *ngIf="toggleStatusNewWind=='false'? true:false">Wind Power - Turned OFF
                            </div>
                            <div id="DhwText" *ngIf="toggleStatusNewDhw=='true'? true:false">Domestic Hot Water - Turned
                                ON </div>
                            <div id="DhwText" *ngIf="toggleStatusNewDhw=='false'? true:false">Domestic Hot Water -
                                Turned OFF</div>
                        </div>

                        <div class="buttonStep">
                            <button (click)="clickMeSubForward()" class="nextStepBotRenewDes" mat-raised-button
                                color="primary">Next</button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Infiltration" [disabled]="isUpdated===true">

                    <div class="tabBody">
                        <div class="tabInnerBody">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="table-responsive">
                                    <table class="w-100 table table-bordered">
                                        <thead>
                                            <tr>
                                                <th class="width-20"></th>
                                                <th colspan="2" class="text-center">INFILTRATION</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th class="text-center">l/s/m2(facade)</th>
                                                <th [ngClass]="{'editableHeaderClass': contedit === true}" class="text-center">Lumpsum Cost($)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="infitem" *ngFor="let folder of infData?.projLists">
                                                <td class="width-20" *ngIf='folder.infiltration_checked == "Yes"'> 
                                                    <mat-checkbox
                                        *ngIf='folder.infiltration_checked == "Yes"'
                                        [checked]="message.includes(folder.infiltration_ref)  && currentHideArr.indexOf('INFILTRATION') == -1" [value]="folder.inf" [disabled]="true"
                                        title="To edit variable selection please go to variable wizard screen"></mat-checkbox>
                                                    </td>
                                                <td *ngIf='folder.infiltration_checked == "Yes"' [ngClass]="{'editableSideClass': contedit === true}" class="col text-center width-30" id="inf-{{folder.inf}}">{{folder.inf_val}}</td>
                                                <td *ngIf='folder.infiltration_checked == "Yes"' class="col text-center width-50" id="infnew-{{folder.inf_val}}" (click)="getIdfirstInf($event,folder.inf)"
                                                (blur)="getText($event,0,50000)" (blur)="getHvacInf(folder.inf_val)"
                                                (keydown)="getDefVal($event)"
                                                attr.contenteditable="{{contedit}}">{{folder.infiltration_cost}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                        </div>
                        </div>

                    </div>
                    <!-- Custom Baseline-->
                        <div class="row">

                            <div class="col-md-3">
                                <div class="table-responsive">
                                    <table class="w-100 table table-bordered">
                                       
                                        <tbody>
                                            <tr>
                                                <td colspan="3">
                                                    <select class="w-100 removeBorderSelect text-center" [(ngModel)]="newcustBaseInf" name="elegas" id="UltraSeven"
                            title="To edit variable selection please go to variable wizard screen" [disabled]="true"
                            *ngIf="newToggleEditable=='true'">
                            <option *ngFor="let folder of infCostData?.projLists | slice:0:3" [value]="folder.inf"
                                selected="  ">{{folder.inf_val}} W/m2</option>

                        </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="buttonStep">
                            <button (click)="clickMeSubForward()" class="nextStepBotRenew" mat-raised-button
                            color="primary">Next</button>
                        </div>
                    </div>
                   <!-- <div>
                     <div class="matContent  mt-2">

                        <mat-list id="floor_cost">
                            <div style="width: 105% !important;height: 55px !important;" class="matheader">
                                <h3>INFILTRATION</h3>

                                
                                <h3 style="padding-top: 0px !important;"><span
                                        style="width: 51%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 8px"
                                        class="verticle_divider_Wall">l/s/m2(facade)</span><span
                                        style="width: 49%;border-color:#fff;border-right: 0px;border-bottom: 0px;height:inherit;padding-top: 8px"
                                        class="verticle_divider_Wall"> Lumpsum Cost($)</span></h3>
                            </div>

                            <div style="width: 114%;">
                                <mat-list-item id="flooritem" *ngFor="let folder of infData?.projLists ">
                                    <mat-checkbox style="margin-top:4px;margin-left:-114%"
                                        *ngIf='folder.infiltration_checked == "Yes"'
                                        [checked]="message.includes(folder.inf)" [value]="folder.inf" [disabled]="true"
                                        title="To edit variable selection please go to variable wizard screen"></mat-checkbox>
                                    <h4 style="padding:0px !important" mat-line
                                        *ngIf='folder.infiltration_checked == "Yes"'><span
                                            style="width:50%;padding: 2px 0px 2px 0px;" id="inf-{{folder.inf}}"
                                            class="verticle_divider_Wall">{{folder.inf}} </span><span
                                            style="width:50%;padding: 2px 0px 2px 0px;" class="verticle_divider_Wall"
                                            id="infnew-{{folder.inf_val}}" (click)="getIdfirstInf($event,folder.inf)"
                                            (blur)="getText($event,0,50000)" (blur)="getHvacInf(folder.inf_val)"
                                            (keydown)="getDefVal($event)"
                                            attr.contenteditable="{{contedit}}">{{folder.infiltration_cost}}</span></h4>


                                </mat-list-item>
                            </div>
                        </mat-list>
                    </div>

                    <div class="buttonStep">
                        <button (click)="clickMeSubForward()" class="nextStepBotRenew" mat-raised-button
                        color="primary">Next Step</button>
                    </div>
                    <div id="cuslineLight">
                        <select [(ngModel)]="newcustBaseInf" name="elegas" id="UltraSeven"
                            title="To edit variable selection please go to variable wizard screen" [disabled]="true"
                            *ngIf="newToggleEditable=='true'">
                            <option *ngFor="let folder of infCostData?.projLists | slice:0:3" [value]="folder.inf"
                                selected="  ">{{folder.inf_val}} W/m2</option>

                        </select>
                    </div>
                </div> -->
                </mat-tab>
                <mat-tab label="Lighting" [disabled]="isUpdated===true">


                    <div class="tabBody">
                        <div class="tabInnerBody">
                            <div class="row">
                                <!-- Proposed Lighting -->

                                <div class="col-md-3">
                                    <div class="table-responsive">
                                        <table class="w-100 table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th colspan="3" class="text-center">LIGHTING</th>
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    <th class="text-center">W/m2</th>
                                                    <th class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">Cost($/m2)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr id="lightingitem_cost" *ngFor="let folder of lightData?.projLists | slice:0:1 ">
                                                    <td class="col text-center">Proposed Lighting</td>
                                                    <td class="col text-center" [ngClass]="{'editableSideClass': contedit === true}">{{proposedLight }} W/m2</td>
                                                    <td class="col text-center" id="btnnew-{{proposedLight}}" (click)="getIdfirstLighting(proposedLight)"
                                                    (blur)="getText($event,0,500)" (blur)="getHvacLighting(proposedLight)"
                                                    (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{contedit}}">{{proposedLightCost}}</td>
                                                </tr>
                                                <tr id="lightingitem_cost" >
                                                    <td class="col text-center">Reference Lighting</td>
                                                    <td class="col text-center" [ngClass]="{'editableSideClass': contedit === true}">{{refLight }} W/m2</td>
                                                    <td class="col text-center" id="btnnew-{{refLight}}" (click)="getIdfirstLighting(refLight)"
                                                    (blur)="getText($event,0,500)" (blur)="getHvacLighting(refLight)"
                                                    (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{contedit}}">{{refLightCost}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="table-responsive">
                                        <table class="w-100 table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="width-15"></th>
                                                    <th colspan="2" class="text-center">DAYLIGHT SENSOR</th>
                                                </tr>
                                                <tr>
                                                    <th class="width-15"></th>
                                                    <th colspan="2" class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">Lumpsum Cost($)</th>
                                                </tr>
                                            </thead>
                                            <tbody id="lightingitemsen_cost">
                                                <tr id="lightingitem"  *ngFor="let folder of lightData?.projLists ">
                                                    <td class="text-center width-15">
                                                        <mat-checkbox class="margin-top-8"
                                    [checked]="message.includes(folder.daylight_checked)  && currentHideArr.indexOf('DL') == -1"
                                    [value]="folder.daylight_sensor" [disabled]="true"
                                    title="To edit variable selection please go to variable wizard screen"></mat-checkbox>
                                                    </td>
                                                    <td [ngClass]="{'editableSideClass': contedit === true}" class="col text-center width-50" id="btn-{{folder.daylight_sensor}}">{{folder.daylight_sensor}}</td>
                                                    <td  class="col text-center width-50" id="btnnew-{{folder.daylight_sensor}}"
                                                    (click)="getIdfirstDls(folder.daylight_sensor)"
                                                    (blur)="getText($event,0,100000)" (blur)="getHvacDls(folder.daylight_sensor)"
                                                    (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{contedit}}">{{folder.daylight_sensor_cost}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div class="row">
                            <!-- CUSTOM BASELine -->

                            <div class="col-md-3">
                                <div class="table-responsive">
                                    <table class="w-100 table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td colspan="3">
                                                    <select class="w-100 removeBorderSelect text-center" [(ngModel)]="newcustBaseLighting" name="elegas" id="UltraSeven"
                            title="To edit variable selection please go to variable wizard screen" [disabled]="true"
                            *ngIf="newToggleEditable=='true'">
                            <option *ngFor="let folder of lightDataCost?.projLists | slice:0:4" [value]="folder.lpd"
                                selected="newcustBaseLighting">{{folder.lpd_val}} W/m2</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="table-responsive">
                                    <table class="w-100 table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td colspan="3">
                                                    <select class="w-100 removeBorderSelect text-center" [(ngModel)]="newcustBaseDl" name="elegas" id="UltraEight"
                                                    title="To edit variable selection please go to variable wizard screen" [disabled]="true"
                                                    *ngIf="newToggleEditable=='true'">
                                                    <option *ngFor="let folder of lightDataCost?.projLists | slice:0:2"
                                                        [value]="folder.daylight_sensor" selected="newcustBaseDl">{{folder.daylight_sensor}}
                                                    </option>
                        
                                                </select>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="buttonStep">
                            <button (click)="clickMeSubForward()" class="nextStepBotRenew" mat-raised-button
                            color="primary">Next</button>
                        </div>


                        
                    </div>




<!-- 
                    <div class="matContent  mt-2">

                        <mat-list style="width:16%!important" class="lighting">

                            <div style="width: 92% !important;height: 64px !important;" class="matheader">
                                <h3>LIGHTING</h3>

                                <h3 style="padding-top: 0px !important;height:36px !important"><span
                                        style="width: 51%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 8px"
                                        class="verticle_divider_Wall">W/m2</span><span
                                        style="width: 49%;border-color:#fff;border-right: 0px;border-bottom: 0px;height:inherit;padding-top: 8px"
                                        class="verticle_divider_Wall">Cost($/m2)</span></h3>
                             
                            </div>


                            <mat-list-item id="lightingitem_cost">

                                <h4 mat-line>Proposed Lighting</h4>
                                <p mat-line>
                                    <span style="width:73px" class="verticle_divider_Wall"> {{proposedLight }}
                                        W/m2
                                    </span>
                                    <span style="width:73px" class="verticle_divider_Wall"
                                        id="btnnew-{{proposedLight}}" (click)="getIdfirstLighting(proposedLight)"
                                        (blur)="getText($event,0,500)" (blur)="getHvacLighting(proposedLight)"
                                        (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contedit}}">{{proposedLightCost}}
                                    </span>



                            </mat-list-item>
                            <mat-list-item id="lightingitem_cost">
                                <h4 mat-line>Reference Lighting</h4>
                                <p mat-line>
                                    <span style="width:73px" class="verticle_divider_Wall"> {{refLight }}
                                        W/m2
                                    </span>
                                    <span style="width:73px" class="verticle_divider_Wall"
                                        id="btnnew-{{refLight}}" (click)="getIdfirstLighting(refLight)"
                                        (blur)="getText($event,0,500)" (blur)="getHvacLighting(refLight)"
                                        (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contedit}}">{{refLightCost}}
                                    </span>



                            </mat-list-item>

                        </mat-list>


                        <mat-list id="daylight">
                            <div class="matheader">
                                <h3>DAYLIGHT SENSOR</h3>
                                <hr />
                                <h3> Lumpsum cost ($)</h3>
                            </div>



                            <mat-list-item id="lightingitemsen_cost"
                                *ngFor="let folder of lightData?.projLists | slice:0:2 ">
                                <mat-checkbox style="margin-top:8px!important"
                                    [checked]="message.includes(folder.daylight_sensor)"
                                    [value]="folder.daylight_sensor" [disabled]="true"
                                    title="To edit variable selection please go to variable wizard screen"></mat-checkbox>
                                <h4 mat-line>
                                    <span id="btn-{{folder.daylight_sensor}}"
                                        class="verticle_divider_Wall">{{folder.daylight_sensor}}
                                    </span>
                                    <span
                                        class="verticle_divider_Wall" id="btnnew-{{folder.daylight_sensor}}"
                                        (click)="getIdfirstDls(folder.daylight_sensor)"
                                        (blur)="getText($event,0,100000)" (blur)="getHvacDls(folder.daylight_sensor)"
                                        (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contedit}}">{{folder.daylight_sensor_cost}}
                                    </span></h4>



                            </mat-list-item>

                        </mat-list>



                    </div> -->

                    
                    <!-- <div id="cuslineLight">
                        <select [(ngModel)]="newcustBaseLighting" name="elegas" id="UltraSeven"
                            title="To edit variable selection please go to variable wizard screen" [disabled]="true"
                            *ngIf="newToggleEditable=='true'">
                            <option *ngFor="let folder of lightDataCost?.projLists | slice:0:4" [value]="folder.lpd"
                                selected="newcustBaseLighting">{{folder.lpd_val}} W/m2</option>

                        </select>
                        <select [(ngModel)]="newcustBaseDl" name="elegas" id="UltraEight"
                            title="To edit variable selection please go to variable wizard screen" [disabled]="true"
                            *ngIf="newToggleEditable=='true'">
                            <option *ngFor="let folder of lightDataCost?.projLists | slice:0:2"
                                [value]="folder.daylight_sensor" selected="newcustBaseDl">{{folder.daylight_sensor}}
                            </option>

                        </select>
                    </div> -->
                    <!-- <button (click)="clickMeSubBack()" class="back" mat-raised-button color="default">Back</button> -->

                    <!-- <button (click)="clickMeSubBack()" class="backTop" mat-raised-button color="default">Back</button>
                    <button (click)="clickMeSubBack()" class="back" mat-raised-button color="default">Back</button>
                      <button (click)="clickMeSubForward()" class="nextStepBot" mat-raised-button color="primary">Next Step</button>
                      <button (click)="clickMeSubForward()" class="nextStepTop" mat-raised-button color="primary">Next Step</button> -->
                </mat-tab>
                <mat-tab label="HVAC AREA1" [disabled]="isUpdated===true">
                    <div class="tabBody">
                        <div class="tabInnerBody">
                            <div class="hvacArea" id="hvaccost">
                                <div class="row">
                                <div class="col-md-6">
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="width-10"></th>
                                                    <th class="width-15"></th>
                                                    <th class="width-40 text-center">HVAC AREA 1 - PRIMARY HVAC
                                                        SYSTEM</th>
                                                    <th colspan="3" class="text-center">
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <th class="text-center width-10"></th>
                                                    <th class="text-center width-15">System Tag</th>
                                                    <th class="text-center width-40">System Description</th>
                                                    <th class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">Distribution Cost ($/m2)</th>
                                                    <th class="text-center"  [ngClass]="{'editableHeaderClass': contedit === true}">Heating Cost ($/kW)</th>
                                                    <th class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">Cooling Cost ($/TR)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr id="hvacitem" *ngFor="let folder of hvDataPrimary">
                                                    <td class="width-10">
                                                        <mat-checkbox
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                                        [checked]="(message.includes(folder.HVAC_system)  && currentHideArr.indexOf('HVAC') == -1) || newEmail == 'demo@ecomatrix.io'" [value]="folder.HVAC_system"
                                                        (change)="checkValHvac()" disabled
                                                        ></mat-checkbox>
                                                    </td>
                                                    <td class="text-center text-ellipsis width-15" (click)="getIdfirstHvac(folder.HVAC_system)"> 
                                                        {{folder.hvac_system_id}}
                                                    </td>
                                                    <td class="text-center width-40 text-ellipsis" [ngClass]="{'editableSideClass': contedit === true}" title="{{folder.HVAC_system }}" (keydown)="getDefVal($event)">
                                                        {{folder.HVAC_system }}
                                                    </td>
                                                    <td class="text-center" id="btnnew-{{folder.hvac_system_id}}"
                                                    (click)="getIdfirstDist(folder.hvac_system_id)" (blur)="getText($event,0,1000)"
                                                    (blur)="getHvacHvac(folder.hvac_system_id, 1)" (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{contedit}}"> {{folder.distributionCost }}
                                                    </td>
                                                    <td class="text-center" id="btnnewtwo-{{folder.hvac_system_id}}"
                                                    (click)="getIdfirstHeat(folder.hvac_system_id)"
                                                    (blur)="getHvacHvactwo(folder.hvac_system_id,1)" (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{contedit}}"> {{folder.heatingCost }}

                                                    </td>
                                                    <td class="text-center" id="btnnewthree-{{folder.hvac_system_id}}"
                                                    (click)="getIdfirstHvacthree(folder.hvac_system_id)"
                                                    (blur)="getText($event,0,2000)"
                                                    (blur)="getHvacHvacthree(folder.hvac_system_id,1)" (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{contedit}}"> {{folder.coolingCost }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <!-- <tfoot>
                                                <tr>
                                                    <th class="text-center width-10"></th>
                                                    <th class="text-center">{{selectedCustBaseHvac}}</th>
                                                    <th class="text-center">
                                                        <select class="w-100 removeBorderSelect text-center"
                                                        [(ngModel)]="newcustBaseHvac" name="elegas" id="UltraTen"
                                                        title="To edit variable selection please go to variable wizard screen" [disabled]="true"
                                                        *ngIf="newToggleEditable=='true'"
                                                        title="To edit variable selection please go to variable wizard screen">
                                                        <option *ngFor="let folder of hvDataCost?.projLists" [value]="folder.HVAC_system"
                                                            selected="newcustBaseHvac">{{folder.HVAC_system}}</option>
                        
                                                        </select>
                                                    </th>
                                                    <th class="text-center">{{distCostPrim}}</th>
                                                    <th class="text-center">{{hCostPrim}}</th>
                                                    <th class="text-center">{{cCostPrim}}</th>
                                                </tr>
                                            </tfoot> -->
                                        </table>
                                    </div>
                                </div> 
                                
                                <div class="col-md-6">
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="width-10"></th>
                                                    <th colspan="3" class="text-center">HVAC AREA 1 - FRESH AIR
                                                        SYSTEM
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <th class="text-center"></th>
                                                    <th class="text-center">System Tag</th>
                                                    <th class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">HEAT RECOVERY YES Lumpsum Cost($)</th>
                                                    <th class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">HEAT RECOVERY NO Lumpsum Cost($)
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr id="hvacitemSec" *ngFor="let folder of freshAirPrim">
                                                    <td class="width-10">
                                                        <mat-checkbox
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}" [checked]="currentHideArr.indexOf('HEAT') == -1 || newEmail == 'demo@ecomatrix.io'"
                                                        [value]="folder.HVAC_system" (change)="checkValHvac()"
                                                        [disabled]="folder.HVAC_system == disbHvacAsh || folder.HVAC_system == disbHvacNec"></mat-checkbox>
                                                    </td>
                                                    <td class="text-center" [ngClass]="{'editableSideClass': contedit === true}" (keydown)="getDefVal($event)"> {{folder.active_hvac_system_id }}</td>
                                                    <td class="text-center hvacItemSec-system" title="{{folder.HVAC_system }}"
                                                    id="fa-{{folder.active_hvac_system_id}}"
                                                    (click)="getFirstLumpsum(folder.active_hvac_system_id)"
                                                    (blur)="getText($event,0,10000000)"
                                                    (blur)="onBlurMethodLumpsum(folder.active_hvac_system_id,'Y',1)"
                                                    (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{contedit}}">{{folder.ERVY_Lumpsum_Cost }}</td>
                                                    <td class="text-center" id="fa2-{{folder.active_hvac_system_id}}"
                                                    (click)="getSecondLumpsum(folder.active_hvac_system_id)"
                                                    (blur)="getText($event,0,10000000)"
                                                    (blur)="onBlurMethodLumpsum(folder.active_hvac_system_id,'N',1)"
                                                    (keydown)="getDefVal($event)" attr.contenteditable="{{contedit}}">
                                                    {{folder.ERVN_Lumpsum_Cost }}</td>
                                                </tr>
                                            </tbody>
                                            <!-- <tfoot>
                                                <tr>
                                                    <th class="width-10"></th>
                                                    <th class="text-center">{{selectedCustBaseHvac}}</th>
                                                    <th class="text-center">{{hrYLumpsum}}</th>
                                                    <th class="text-center">{{cCostPrim}}</th>
                                                </tr>
                                            </tfoot> -->
                                        </table>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="table table-bordered customBaseLineTable">
                                        <tbody>
                                            <tr>
                                                <td class="text-center width-12"></td>
                                                <td class="text-center width-20">{{selectedCustBaseHvac}}</td>
                                                <td class="text-center width-50">
                                                    <select class="w-100 removeBorderSelect text-center"
                                                    [(ngModel)]="selectedCustBaseHvacName" name="elegas" id="UltraTen"
                                                    title="To edit variable selection please go to variable wizard screen" [disabled]="true"
                                                    *ngIf="newToggleEditable=='true'"
                                                    title="To edit variable selection please go to variable wizard screen">
                                                    <option *ngFor="let folder of hvDataCost?.projLists" [value]="folder.HVAC_system"
                                                        selected="selectedCustBaseHvacName">{{folder.HVAC_system}}</option>
                    
                                                    </select>
                                                </td>
                                                <td class="text-center width-15">{{distCostPrim}}</td>
                                                <td class="text-center width-15">{{hCostPrim}}</td>
                                                <td class="text-center width-15">{{cCostPrim}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>    
                            </div>

                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td class="width-11"></td>
                                                <td class="text-center">{{selectedCustBaseHvac}}</td>
                                                <td class="text-center">{{hrYLumpsum}}</td>
                                                <td class="text-center">{{hrNLumpsum}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>        
                            </div>
                        </div>

                        <div class="buttonStep">
                            <button  (click)="clickMeSubForward()" class="nextStepBotRenewFin"
                            mat-raised-button color="primary">Next</button>
                        </div>
                    </div>
                    <!-- <div class="matContent  mt-2" style="height:100%;overflow:hidden;">

                        <mat-list class="hvac" id="hvaccost">

                            <div style="text-align:left;width:600px;height:64px" class="matheader">
                                <h3 style="text-align:center">HVAC AREA 1 - PRIMARY HVAC SYSTEM</h3>

                                <h3 style="padding-top: 0px !important;height:36px !important"><span
                                        style="width: 21.5%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;"
                                        class="verticle_divider_hvac">SYSTEM TAG</span><span
                                        style="width: 22%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;"
                                        class="verticle_divider_hvac">SYSTEM DESCRIPTION</span><span
                                        style="width: 18%;border-color:#fff;border-bottom: 0px;height:inherit;font-size: 11px;"
                                        class="verticle_divider_hvac">Distribution Cost ($/m2)</span><span
                                        style="width: 21%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;"
                                        class="verticle_divider_hvac">Heating Cost ($/kw)</span><span
                                        style="width: 17.5%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;border-right: 0px;"
                                        class="verticle_divider_hvac">Cooling Cost ($/TR)</span></h3>

                            </div>

                            <mat-list-item style="width:616px;" id="hvacitem" *ngFor="let folder of hvDataPrimary">
                                <mat-checkbox style="margin-left:-104%"
                                    [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}"
                                    [checked]="message.includes(folder.HVAC_system)" [value]="folder.HVAC_system"
                                    (change)="checkValHvac()"
                                    [disabled]="folder.HVAC_system == disbHvacAsh || folder.HVAC_system == disbHvacNec"></mat-checkbox>
                                <p mat-line>
                                    <span class="verticle_divider_hvac1" style="width: 21.5%;"
                                        (click)="getIdfirstHvac(folder.HVAC_system)"> {{folder.hvac_system_id
                                        }}
                                    </span>
                                    <span class="verticle_divider_hvac1"
                                        style="width: 22%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;vertical-align: top;"
                                        title="{{folder.HVAC_system }}" (keydown)="getDefVal($event)">
                                        {{folder.HVAC_system }}</span>
                                        <span class="verticle_divider_hvac1"
                                        style="width: 18%;" id="btnnew-{{folder.hvac_system_id}}"
                                        (click)="getIdfirstDist(folder.hvac_system_id)" (blur)="getText($event,0,1000)"
                                        (blur)="getHvacHvac(folder.hvac_system_id, 1)" (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contedit}}"> {{folder.distributionCost }}</span>
                                        <span
                                        class="verticle_divider_hvac1" style="width: 21%;"
                                        id="btnnewtwo-{{folder.hvac_system_id}}"
                                        (click)="getIdfirstHeat(folder.hvac_system_id)"
                                        (blur)="getHvacHvactwo(folder.hvac_system_id,1)" (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contedit}}"> {{folder.heatingCost }}</span><span
                                        class="verticle_divider_hvac1" style="width: 17.5%;"
                                        id="btnnewthree-{{folder.hvac_system_id}}"
                                        (click)="getIdfirstHvacthree(folder.hvac_system_id)"
                                        (blur)="getText($event,0,2000)"
                                        (blur)="getHvacHvacthree(folder.hvac_system_id,1)" (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contedit}}"> {{folder.coolingCost }}</span></p>


                            </mat-list-item>

                        </mat-list>

                        <mat-list class="hvac" id="hvaccost">

                            <div style="text-align:left;width:589px;height:64px;margin-left: 416px;" class="matheader">
                                <h3 style="text-align:center">HVAC AREA 1 - FRESH AIR SYSTEM</h3>

                                <h3 style="padding-top: 0px !important;height:65px !important">

                                    <span _ngcontent-c32="" class="verticle_divider_hvac"
                                        style="width: 21.5%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;">SYSTEM
                                        TAG</span><span _ngcontent-c32="" class="verticle_divider_hvac"
                                        style="width: 37.5%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;">HEAT
                                        RECOVERY YES Lumpsum Cost($)</span><span _ngcontent-c32=""
                                        class="verticle_divider_hvac"
                                        style="width: 41%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;">HEAT
                                        RECOVERY NO Lumpsum Cost($)</span>
                                </h3>

                            </div>


                            <mat-list-item style="margin-left:416px;width:600px;" id="hvacitemSec"
                                *ngFor="let folder of freshAirPrim">
                                <mat-checkbox style="margin-left:-106%"
                                    [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}" [checked]="true"
                                    [value]="folder.HVAC_system" (change)="checkValHvac()"
                                    [disabled]="folder.HVAC_system == disbHvacAsh || folder.HVAC_system == disbHvacNec"></mat-checkbox>

                                <p mat-line>
                                    <span class="verticle_dividerHvac"
                                        style="width: 9vw;border-right: 1px solid #ccc;border-right: 1px solid #ccc;"
                                        (keydown)="getDefVal($event)"> {{folder.active_hvac_system_id }}</span>
                                        <span
                                        class="verticle_dividerHvac" title="{{folder.HVAC_system }}"
                                        style="width: 16vw;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;vertical-align: top;border-right: 1px solid #ccc;"
                                        id="fa-{{folder.active_hvac_system_id}}"
                                        (click)="getFirstLumpsum(folder.active_hvac_system_id)"
                                        (blur)="getText($event,0,1000)"
                                        (blur)="onBlurMethodLumpsum(folder.active_hvac_system_id,'Y',1)"
                                        (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contedit}}">{{folder.ERVY_Lumpsum_Cost }}</span><span
                                        class="verticle_dividerHvac" style="width: 17.6vw;border-right: 1px solid #ccc;"
                                        id="fa2-{{folder.active_hvac_system_id}}"
                                        (click)="getSecondLumpsum(folder.active_hvac_system_id)"
                                        (blur)="getText($event,0,1000)"
                                        (blur)="onBlurMethodLumpsum(folder.active_hvac_system_id,'N',1)"
                                        (keydown)="getDefVal($event)" attr.contenteditable="{{contedit}}">
                                        {{folder.ERVN_Lumpsum_Cost }}</span></p>


                            </mat-list-item>

                        </mat-list>
                        <button (click)="clickMeSubForward()" class="nextStepBotRenewFin"
                            mat-raised-button color="primary">Next</button>
                    </div>
                    <div id="cuslineHvac">



                        <span class="brdrCls"
                            style="width: 22%;display: inline-block;">{{selectedCustBaseHvac}}</span>
                            <span>
                                <select
                                [(ngModel)]="newcustBaseHvac" name="elegas" id="UltraTen"
                                title="To edit variable selection please go to variable wizard screen" [disabled]="true"
                                *ngIf="newToggleEditable=='true'"
                                title="To edit variable selection please go to variable wizard screen">
                                <option *ngFor="let folder of hvDataCost?.projLists" [value]="folder.HVAC_system"
                                    selected="newcustBaseHvac">{{folder.HVAC_system}}</option>

                            </select>
                        </span>
                        <span class="brdrCls"
                            style="width: 17%;display: inline-block;">{{distCostPrim}}
                        </span>
                        <span class="brdrCls"
                            style="width: 21%;display: inline-block;">{{hCostPrim}}
                        </span><span class="brdrCls"
                            style="width: 17%;display: inline-block;">{{cCostPrim}}
                        </span>
                    </div>
                    <div id="cuslineHvac1">




                        <span class="brdrCls"
                            style="width: 22%;display: inline-block;">{{selectedCustBaseHvac}}</span><span
                            class="brdrCls" style="width: 38%;display: inline-block;">{{hrYLumpsum}}</span><span
                            class="brdrCls" style="width: 40%;display: inline-block;">{{hrNLumpsum}}</span>


                       
                    </div> -->

                </mat-tab>

                <mat-tab label="HVAC AREA2">


                    <div class="tabBody">
                        <div class="tabInnerBody">
                            <div class="hvacArea" id="hvaccost">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th class="width-10"></th>
                                                        <th colspan="5" class="text-center">HVAC AREA 2 - PRIMARY HVAC
                                                            SYSTEM
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <th class="text-center width-10"></th>
                                                        <th class="text-center">System Tag</th>
                                                        <th class="text-center width-15">System Description</th>
                                                        <th class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">Distribution Cost ($/m2)</th>
                                                        <th class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">Heating Cost ($/kW)</th>
                                                        <th class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">Cooling Cost ($/TR)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr id="hvacitem" *ngFor="let folder of hvDataSec">
                                                    <td class="width-10"> 
                                                        <mat-checkbox
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}" [checked]="true"
                                                        [value]="folder.HVAC_system" (change)="checkValHvac()"
                                                        [disabled]="true">
                                                        </mat-checkbox>
                                                    </td>
                                                    <td class="text-center" d="btnnew-{{folder.HVAC_system}}" (keydown)="getDefVal($event)">
                                                        {{folder.hvac_system_id }}
                                                    </td>
                                                    <td class="text-center text-ellipsis" [ngClass]="{'editableSideClass': contedit === true}" title="{{folder.HVAC_system }}" id="btnnew-{{folder.HVAC_system}}"
                                                    (keydown)="getDefVal($event)"> {{folder.HVAC_system }}
                                                </td>
                                                <td class="text-center" id="btnnewtwoHvacSec-{{folder.hvac_system_id}}"
                                                (click)="getIdfirstSecHvac(folder.hvac_system_id)"
                                                (blur)="getText($event,0,1000)" (blur)="getHvacHvac(folder.hvac_system_id,2)"
                                                (keydown)="getDefVal($event)" attr.contenteditable="{{contedit}}">
                                                {{folder.distributionCost }}
                                            </td>
                                            <td class="text-center" id="btnnewHvacHeat-{{folder.hvac_system_id}}"
                                            (click)="getIdfirstSecHvacHeat(folder.hvac_system_id)"
                                            (blur)="getHvacHvactwo(folder.hvac_system_id,2)" (keydown)="getDefVal($event)"
                                            attr.contenteditable="{{contedit}}"> {{folder.heatingCost }}</td>
                                            <td class="text-center" id="btnnewHvacCool-{{folder.hvac_system_id}}"
                                            (click)="getIdfirstHvacCool(folder.hvac_system_id)"
                                            (blur)="getText($event,0,2000)"
                                            (blur)="getHvacHvacthree(folder.hvac_system_id,2)" (keydown)="getDefVal($event)"
                                            attr.contenteditable="{{contedit}}"> {{folder.coolingCost }}</td>
                                        </tr>
                                                </tbody>
                                                <!-- <tfoot>
                                                    <tr>
                                                        <th class="text-center width-10"></th>
                                                        <th class="text-center">{{selectedCustBaseHvacSec}}</th>
                                                        <th class="text-center">
                                                            <select class="w-100 removeBorderSelect text-center"
                                                            [(ngModel)]="selectedCustBaseHvacSecName" name="elegas" id="UltraTen" [disabled]="true"
                                                            *ngIf="newToggleEditable=='true'">
                                                            <option *ngFor="let folder of hvDataSec" [value]="folder.HVAC_system"
                                                                selected="selectedCustBaseHvacSecName">{{folder.HVAC_system}}</option>
                            
                                                        </select>
                                                        </th>
                                                        <th class="text-center">{{distCostSec}}</th>
                                                        <th class="text-center">{{hCostSec}}</th>
                                                        <th class="text-center">{{cCostSec}}</th>
                                                    </tr>
                                                </tfoot> -->
                                            </table>
                                        </div>
                                    </div>   
                                    
                                    <div class="col-md-6">
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th class="width-10"></th>
                                                        <th colspan="3" class="text-center">HVAC AREA 2 - FRESH AIR
                                                            SYSTEM
                                                        </th>
    
                                                    </tr>
                                                    <tr>
                                                        <th class="text-center width-10"></th>
                                                        <th class="text-center">System Tag</th>
                                                        <th class="text-center">System Description</th>
                                                        <th class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">Lumpsum Cost($)
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr id="hvacitemSec" *ngFor="let folder of freshAirSec">
                                                        <td class="width-10">
                                                             <mat-checkbox
                                                            [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}" [checked]="true"
                                                            [value]="folder.HVAC_system" (change)="checkValHvac()"
                                                            [disabled]="true"></mat-checkbox></td>
                                                            <td class="text-center" id="btnnew-{{folder.active_hvac_system_id}}" (keydown)="getDefVal($event)">
                                                                {{folder.active_hvac_system_id }}
                                                            </td>
                                                            <td class="text-center col text-ellipsis" [ngClass]="{'editableSideClass': contedit === true}" id="btnnew-{{folder.active_hvac_system_id}}"
                                                            (blur)="getHvac(folder.active_hvac_system_id)" (keydown)="getDefVal($event)">
                                                            {{folder.freshAir_system }}</td>
                                                            <td class="text-center col" id="lumpsumSec-{{folder.active_hvac_system_id}}"
                                                            (click)="getFirstLumpsumSec(folder.active_hvac_system_id)"
                                                            (blur)="getText($event,0,1000)"
                                                            (blur)="onBlurMethodLumpsum(folder.active_hvac_system_id,'Y',2)"
                                                            (keydown)="getDefVal($event)"
                                                            attr.contenteditable="{{contedit}}">{{folder.heat_recovery_cost_lumpsum
                                                            }}</td>

                                                    </tr>
                                                </tbody>
                                                <!-- <tfoot>
                                                    <tr>
                                                        <th class="width-10"></th>
                                                        <th class="text-center">{{selectedCustBaseHvacSec}}</th>
                                                        <th class="text-center"> 
                                                            <select class="removeBorderSelect w-100 text-center"
                                                            [(ngModel)]="selectedCustBaseHvacSec" id="UltraNine1" disabled>
                                                            <option *ngFor="let folder of freshAirSec" [value]="folder.active_hvac_system_id"
                                                                selected="selectedCustBaseHvacSec">{{folder.freshAir_system}}</option>
                                                        </select>
                                                    </th>
                                                    <th class="text-center">{{hrLumpsumSec}}</th>
                                                    </tr>
                                                </tfoot> -->
                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td class="text-center width-18"></td>
                                                        <td class="text-center">{{selectedCustBaseHvacSec}}</td>
                                                        <td class="text-center">
                                                            <select class="w-100 removeBorderSelect text-center"
                                                            [(ngModel)]="selectedCustBaseHvacSecName" name="elegas" id="UltraTen" [disabled]="true"
                                                            *ngIf="newToggleEditable=='true'">
                                                            <option *ngFor="let folder of hvDataSec" [value]="folder.HVAC_system"
                                                                selected="selectedCustBaseHvacSecName">{{folder.HVAC_system}}</option>
                            
                                                        </select>
                                                        </td>
                                                        <td class="text-center">{{distCostSec}}</td>
                                                        <td class="text-center">{{hCostSec}}</td>
                                                        <td class="text-center">{{cCostSec}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td class="width-11"></td>
                                                        <td class="text-center">{{selectedCustBaseHvacSec}}</td>
                                                        <td class="text-center"> 
                                                            <select class="removeBorderSelect w-100 text-center"
                                                            [(ngModel)]="selectedCustBaseHvacSec" id="UltraNine1" disabled>
                                                            <option *ngFor="let folder of freshAirSec" [value]="folder.active_hvac_system_id"
                                                                selected="selectedCustBaseHvacSec">{{folder.freshAir_system}}</option>
                                                        </select>
                                                    </td>
                                                    <td class="text-center">{{hrLumpsumSec}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="buttonStep">
                            <!-- <button (click)="clickMeSubForward()" class="nextStepBotRenewFin "
                                mat-raised-button color="primary">Next</button> -->
                            <button (click)="clickMeSubForward()" class="nextStepTop" mat-raised-button
                                color="primary">Next</button>
                        </div>
                    </div>

                    <!-- <div class="matContent  mt-2" style="height:100%;overflow:hidden;padding-bottom: 0px;">
                        <mat-list class="hvac" id="hvaccost">

                            <div style="text-align:left;width:600px;height:64px" class="matheader">
                                <h3 style="text-align:center">HVAC AREA 2 - PRIMARY HVAC SYSTEM</h3>

                                <h3 style="padding-top: 0px !important;height:36px !important"><span
                                        style="width: 21.5%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;"
                                        class="verticle_divider_hvac">SYSTEM TAG</span><span
                                        style="width: 22%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;"
                                        class="verticle_divider_hvac">SYSTEM DESCRIPTION</span><span
                                        style="width: 18%;border-color:#fff;border-bottom: 0px;height:inherit;font-size: 11px;"
                                        class="verticle_divider_hvac">Distribution Cost ($/m2)</span><span
                                        style="width: 21%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;"
                                        class="verticle_divider_hvac">Heating Cost ($/kw)</span><span
                                        style="width: 17.5%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;border-right: 0px;"
                                        class="verticle_divider_hvac">Cooling Cost ($/TR)</span></h3>

                            </div>

                            <mat-list-item style="width:616px;" id="hvacitem" *ngFor="let folder of hvDataSec">
                                <mat-checkbox style="margin-left:-104%"
                                    [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}" [checked]="true"
                                    [value]="folder.HVAC_system" (change)="checkValHvac()"
                                    [disabled]="folder.HVAC_system == disbHvacAsh || folder.HVAC_system == disbHvacNec"></mat-checkbox>
                                <p mat-line><span class="verticle_divider_hvac1" style="width: 21.5%;"
                                        id="btnnew-{{folder.HVAC_system}}" (keydown)="getDefVal($event)">
                                        {{folder.hvac_system_id }}</span>
                                        <span class="verticle_divider_hvac1"
                                        style="width: 22%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;vertical-align: top;"
                                        title="{{folder.HVAC_system }}" id="btnnew-{{folder.HVAC_system}}"
                                        (keydown)="getDefVal($event)"> {{folder.HVAC_system }}</span><span
                                        class="verticle_divider_hvac1" style="width: 18%;"
                                        id="btnnewtwoHvacSec-{{folder.hvac_system_id}}"
                                        (click)="getIdfirstSecHvac(folder.hvac_system_id)"
                                        (blur)="getText($event,0,1000)" (blur)="getHvacHvac(folder.hvac_system_id,2)"
                                        (keydown)="getDefVal($event)" attr.contenteditable="{{contedit}}">
                                        {{folder.distributionCost }}</span><span class="verticle_divider_hvac1"
                                        style="width: 21%;" id="btnnewHvacHeat-{{folder.hvac_system_id}}"
                                        (click)="getIdfirstSecHvacHeat(folder.hvac_system_id)"
                                        (blur)="getHvacHvactwo(folder.hvac_system_id,2)" (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contedit}}"> {{folder.heatingCost }}</span><span
                                        class="verticle_divider_hvac1" style="width: 16.5%;"
                                        id="btnnewHvacCool-{{folder.hvac_system_id}}"
                                        (click)="getIdfirstHvacCool(folder.hvac_system_id)"
                                        (blur)="getText($event,0,2000)"
                                        (blur)="getHvacHvacthree(folder.hvac_system_id,2)" (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contedit}}"> {{folder.coolingCost }}</span></p>


                            </mat-list-item>

                        </mat-list>
                        <mat-list class="hvac" id="hvaccost">

                            <div style="text-align:left;width:589px;height:64px;margin-left: 416px;" class="matheader">
                                <h3 style="text-align:center">HVAC AREA 2 - FRESH AIR SYSTEM</h3>

                                <h3 style="padding-top: 0px !important;height:65px !important">

                                    <span _ngcontent-c32="" class="verticle_divider_hvac"
                                        style="width: 21.5%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;">SYSTEM
                                        TAG</span><span _ngcontent-c32="" class="verticle_divider_hvac"
                                        style="width: 40.5%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;">SYSTEM
                                        DESCRIPTION</span><span _ngcontent-c32="" class="verticle_divider_hvac"
                                        style="width: 37.5%;border-color:#fff;border-left: 0px;border-bottom: 0px;height:inherit;padding-top: 15px;font-size: 11px;">
                                        Lumpsum Cost($)</span>
                                </h3>

                            </div>


                            <mat-list-item style="margin-left:416px;width:600px;" id="hvacitemSec"
                                *ngFor="let folder of freshAirSec">
                                <mat-checkbox style="margin-left:-106%"
                                    [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}" [checked]="true"
                                    [value]="folder.HVAC_system" (change)="checkValHvac()"
                                    [disabled]="folder.HVAC_system == disbHvacAsh || folder.HVAC_system == disbHvacNec"></mat-checkbox>

                                <p mat-line>
                                    
                                    
                                    <span class="verticle_dividerHvac"
                                        style="width: 21.5%;border-right: 1px solid #ccc;border-right: 1px solid #ccc;"
                                        id="btnnew-{{folder.active_hvac_system_id}}" (keydown)="getDefVal($event)">
                                        {{folder.active_hvac_system_id }}</span>
                                        <span class="verticle_dividerHvac"
                                        style="width: 40.5%;border-right: 1px solid #ccc;border-right: 1px solid #ccc;"
                                        id="btnnew-{{folder.active_hvac_system_id}}"
                                        (blur)="getHvac(folder.active_hvac_system_id)" (keydown)="getDefVal($event)">
                                        {{folder.freshAir_system }}</span><span class="verticle_dividerHvac"
                                        title="{{folder.HVAC_system }}"
                                        style="width: 37.5%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;vertical-align: top;border-right: 1px solid #ccc;"
                                        id="lumpsumSec-{{folder.active_hvac_system_id}}"
                                        (click)="getFirstLumpsumSec(folder.active_hvac_system_id)"
                                        (blur)="getText($event,0,1000)"
                                        (blur)="onBlurMethodLumpsum(folder.active_hvac_system_id,'Y',2)"
                                        (keydown)="getDefVal($event)"
                                        attr.contenteditable="{{contedit}}">{{folder.heat_recovery_cost_lumpsum
                                        }}</span></p>


                            </mat-list-item>

                        </mat-list>
                        <div class="buttonStep">
                            <button (click)="clickMeSubForward()" class="nextStepBotRenewFin "
                                mat-raised-button color="primary">Next</button>
                            <button (click)="clickMeSubForward()" class="nextStepTop" mat-raised-button
                                color="primary">Next</button>
                        </div>
                    </div>

                    <div id="cuslineFr">




                        <span class="brdrCls"
                            style="width: 21.5%;display: inline-block;">{{selectedCustBaseHvacSec}}</span><span>
                                <select
                                [(ngModel)]="selectedCustBaseHvacSecName" name="elegas" id="UltraTen" [disabled]="true"
                                *ngIf="newToggleEditable=='true'">
                                <option *ngFor="let folder of hvDataSec" [value]="folder.HVAC_system"
                                    selected="selectedCustBaseHvacSecName">{{folder.HVAC_system}}</option>

                            </select>
                        </span><span class="brdrCls"
                            style="width: 18%;display: inline-block;">{{distCostSec}}</span><span class="brdrCls"
                            style="width: 21%;display: inline-block;">{{hCostSec}}</span><span class="brdrCls"
                            style="width: 16.5%;display: inline-block;">{{cCostSec}}</span>

                    </div>
                    <div id="cuslineFr1">


                        <span style="display:none"></span><span class="brdrCls"
                            style="width:21.5%;display: inline-block;">{{selectedCustBaseHvacSec}}</span>
                            <span>
                                <select
                                [(ngModel)]="selectedCustBaseHvacSec" id="UltraNine1" disabled>
                                <option *ngFor="let folder of freshAirSec" [value]="folder.active_hvac_system_id"
                                    selected="selectedCustBaseHvacSec">{{folder.freshAir_system}}</option>
                            </select></span><span class="brdrCls"
                            style="width: 37.5%;display: inline-block;">{{hrLumpsumSec}}</span>

                    </div> -->

                </mat-tab>
				<!-- start of humidification changes -->
				<mat-tab label="Humidification / Process">


                    <div class="tabBody">
                        <div class="tabInnerBody">
                            <div class="hvacArea" id="hvaccost">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th class="width-10"></th>
                                                        <th colspan="3" class="text-center">Humidification / Process
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <th class="text-center width-10"></th>
                                                        <th class="text-center">System Tag</th>
                                                        <th class="text-center width-15">ERV Y-Humidifier/Process Cost ($)</th>
                                                        <th class="text-center" >ERV N-Humidifier/Process Cost ($)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr id="hvacitem" *ngFor="let folder of humidification">
                                                    <td class="width-10"> 
                                                        <mat-checkbox
                                                        [ngClass]="{'myclassNew':newEmail == 'demo@ecomatrix.io'}" [checked]="true"
                                                        [value]="folder.hvac_system_id"
                                                        disabled>
                                                        </mat-checkbox>
                                                    </td>
                                                    <td class="text-center" id="btnnew-{{folder.hvac_system_id}}" (keydown)="getDefVal($event)">
                                                        {{folder.hvac_system_id }}
                                                    </td>
                                                    <td class="text-center text-ellipsis" [ngClass]="{'editableSideClass': contedit === true && folder.hum_avlbl==='Y'}" title="{{folder.hvac_system_id }}" id="btnHumY-{{folder.hvac_system_id}}"  attr.contenteditable="{{newEmail == 'demo@ecomatrix.io'?'false':'true' && folder.hum_avlbl==='Y'}}" (click)="getHumValue(folder.hvac_system_id)" (blur)="getHumidification(folder.hvac_system_id)"  (blur)="getText($event,0,100000)"
                                                    (keydown)="getDefVal($event)"> {{folder.hum_avlbl==='Y'? folder.ervy_hum_cost : '-'
													}}
													</td>
													 <td class="text-center text-ellipsis" [ngClass]="{'editableSideClass': contedit === true && folder.hum_avlbl==='Y'}" title="{{folder.hvac_system_id }}" id="btnHumN-{{folder.hvac_system_id}}"  attr.contenteditable="{{newEmail == 'demo@ecomatrix.io'?'false':'true' && folder.hum_avlbl==='Y'}}" (click)="getHumValueN(folder.hvac_system_id)"  (blur)="getHumidificationN(folder.hvac_system_id)"  (blur)="getText($event,0,100000)"
                                                    (keydown)="getDefVal($event)">  {{folder.hum_avlbl==='Y'? folder.ervn_hum_cost : '-'
													}}
													</td>
													</tr>
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>   
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td class="width-11"></td>
                                                    <td class="text-center">{{selectedCustBaseHvac}}</td>
                                                    <td class="text-center">{{humAvlbl==='Y'?humCost:'-'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="buttonStep">
                            <!-- <button (click)="clickMeSubForward()" class="nextStepBotRenewFin "
                                mat-raised-button color="primary">Next</button> -->
                            <button (click)="clickMeSubForward()" class="nextStepTop" mat-raised-button
                                color="primary">Next</button>
                        </div>
                    </div>

                </mat-tab>
				<!--end of humidification changes -->
                <mat-tab label="Domestic Hot Water">
                    <div class="tabBody">
                        <div class="tabInnerBody">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">System Tag</th>
                                                    <th class="text-center" [ngClass]="{'editableHeaderClass': contedit === true}">Lumpsum Cost ($/m2)</th>
                                                </tr>
                                             </thead>   
                                             <tbody>
                                                <tr *ngFor="let fra of freshAir?.DHW">
                                                    <td class="text-center" id="solarAzi" [ngClass]="'noedit_text'" [ngClass]="{'editableSideClass': contedit === true}" >{{fra.active_hvac_system_id}}</td>
                                                    <td class="text-center" (blur)="getText($event,0,10000)"
                                                    (keydown)="getDefVal($event)"
                                                    attr.contenteditable="{{newEmail == 'demo@ecomatrix.io'?'false':'true'}}"
                                                    (blur)="onBlurMethodDhw(fra.active_hvac_system_id)"><span
                                                        id="dhwcost-{{fra.active_hvac_system_id}}"
                                                        (click)="getDhwOption($event,fra.active_hvac_system_id)"
                                                        (blur)="onBlurMethodDhw(fra.active_hvac_system_id)">
                                                        {{fra.dhw_cost}}</span></td>
                                                </tr>
                                             </tbody>
                                            </table>
                                        </div>
                                           
                                    </div>         
                                </div>
                            </div>
                            <div class="col-md-6">
                                
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <tbody>
                                                            <tr>
                                                                        <td class="text-center">{{selectedCustBaseHvacSec}}</td>
                                                                        <td class="text-center"> 
                                                                            {{srcCust}}
                                                                    </td>
                                                                    
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                      </div>          
                        </div>
                        <div class="buttonStep">
                            <button (click)="clickMeForwar()" mat-raised-button
                        color="primary">Next</button>
                        </div>
                    </div>
                    <!-- <div class="matContent">
                        <div class="row">
                            <div class="col-md-8 renewableBox" style="min-width:400px;">
                                <mat-grid-list class="fixedTitle " cols="2" rowHeight="35px">


                                    <mat-grid-tile style="background-color:#ccc" class="newgrid">System
                                        Tag</mat-grid-tile>
                                    <mat-grid-tile class="costcol">Lumpsum Cost ($/m2)</mat-grid-tile>

                                </mat-grid-list>

                                <mat-grid-list cols="2" rowHeight="50px">
                                    <div *ngFor="let fra of freshAir?.DHW">
                                        <mat-grid-tile id="solarAzi" [ngClass]="'noedit_text'">
                                            {{fra.active_hvac_system_id}}</mat-grid-tile>
                                        <mat-grid-tile style="background-color:#fff" (blur)="getText($event,0,10000)"
                                            (keydown)="getDefVal($event)"
                                            attr.contenteditable="{{newEmail == 'demo@ecomatrix.io'?'false':'true'}}"
                                            (blur)="onBlurMethodDhw(fra.active_hvac_system_id)"><span
                                                id="dhwcost-{{fra.active_hvac_system_id}}"
                                                (click)="getDhwOption($event,fra.active_hvac_system_id)"
                                                (blur)="onBlurMethodDhw(fra.active_hvac_system_id)">
                                                {{fra.dhw_cost}}</span></mat-grid-tile>


                                    </div>


                                </mat-grid-list>
                                <div id="cuslineHvac5">
                                    <span class="brdrCls"
                                        style="width: 29.5vw;display: inline-block;">{{selectedCustBaseHvac}}</span><span
                                        class="brdrCls" style="width: 28.5vw;display: inline-block;">{{srcCust}}</span>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    
                </mat-tab>

            </mat-tab-group>



            <!-- <button (click)="clickMeBack()" class="back" mat-raised-button color="default">Back</button>
          <button (click)="goHome()"  class="nextStep" mat-raised-button color="primary">Next Step</button> -->
        </div>
    </mat-tab>
    <mat-tab label="Key Performance Indicators">

        <div class="tabBody">
            <div class="tabInnerBody">
                <div class="row">
                    <div class="col-md-6">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="text-center newgrid">Fuel Source</th>
                                        <th [ngClass]="{'editableHeaderClass': newEmail == 'demo@ecomatrix.io'?'false':'true'}" class="text-center">kG CO2/kWh</th>
                                        <th [ngClass]="{'editableHeaderClass': newEmail == 'demo@ecomatrix.io'?'false':'true'}" class="text-center">$/kWh</th>
                                        <th [ngClass]="{'editableHeaderClass': newEmail == 'demo@ecomatrix.io'?'false':'true'}" class="text-center">Carbon Tax ($/ton of CO2</th>
                                    </tr>
                                 </thead>  
                                 <tbody>
                                    <tr *ngFor="let rewnew of opCostData?.projLists">
                                        <td id="renewKw" [ngClass]="{'editableSideClass': newEmail == 'demo@ecomatrix.io'?'false':'true'}"  class="'noedit_text'">{{rewnew.fuelSource}}</td>
                                        <td id="renewHub" attr.contenteditable="{{newEmail == 'demo@ecomatrix.io'?'false':'true'}}"
                                        (blur)="onBlurGhgCost(rewnew.fuelSource)"> <span id="ghgcost-{{rewnew.fuelSource}}"
                                            (click)="getGhgCost(rewnew.fuelSource)"
                                            (blur)="onBlurGhgCost(rewnew.fuelSource)">{{rewnew.ghgCoeff}}</span>
                                        </td>
                                        <td attr.contenteditable="{{newEmail == 'demo@ecomatrix.io'?'false':'true'}}"
                                        (keydown)="getDefVal($event)" (blur)="onBlurOpCost(rewnew.fuelSource)"><span
                                            id="opcost-{{rewnew.fuelSource}}" (click)="getOpCost(rewnew.fuelSource)"
                                            (blur)="onBlurOpCost(rewnew.fuelSource)"> {{rewnew.opCost}}</span>
                                        </td>
                                        <td attr.contenteditable="{{newEmail == 'demo@ecomatrix.io'?'false':'true'}}"
                                        (blur)="onBlurCarbonTax(rewnew.fuelSource)" (keydown)="getDefVal($event)"><span
                                            id="carbontax-{{rewnew.fuelSource}}" (click)="getCarbonCost(rewnew.fuelSource)"
                                            (blur)="onBlurCarbonTax(rewnew.fuelSource)">
                                            {{rewnew.carbonTax}}</span></td>
                                    </tr>
                                 </tbody>
                            </table>
                        </div> 
                    </div>
                </div>
            </div>
            <div class="buttonStep buttonStepWithoutWizard">
                <button (click)="goHome()" class="nextStepBotRenew" mat-raised-button color="primary"
            ng-disabled="isUpdated==true">Finish</button>
            </div>
        </div>        
        <!-- <div class="matContent">


            <div class="row">

                <div class="col-md-8 renewableBox">
                    <mat-grid-list class="fixedTitle " cols="4" rowHeight="35px">

                        <mat-grid-tile class="newgrid">Fuel Source</mat-grid-tile>
                        <mat-grid-tile class="costcol">kG CO2/kWh</mat-grid-tile>
                        <mat-grid-tile class="costcol">$/kWh</mat-grid-tile>
                        <mat-grid-tile class="costcol">Carbon Tax ($/ton of CO2)</mat-grid-tile>
                    </mat-grid-list>

                    <mat-grid-list cols="4" rowHeight="50px">
                        <div *ngFor="let rewnew of opCostData?.projLists">

                            <mat-grid-tile id="renewKw" [ngClass]="'noedit_text'"> {{rewnew.fuelSource}}</mat-grid-tile>
                            <mat-grid-tile id="renewHub" style="background-color:#fff"
                                attr.contenteditable="{{newEmail == 'demo@ecomatrix.io'?'false':'true'}}"
                                (blur)="onBlurGhgCost(rewnew.fuelSource)"> <span id="ghgcost-{{rewnew.fuelSource}}"
                                    (click)="getGhgCost(rewnew.fuelSource)"
                                    (blur)="onBlurGhgCost(rewnew.fuelSource)">{{rewnew.ghgCoeff}}</span></mat-grid-tile>

                            <mat-grid-tile style="background-color:#fff"
                                attr.contenteditable="{{newEmail == 'demo@ecomatrix.io'?'false':'true'}}"
                                (keydown)="getDefVal($event)" (blur)="onBlurOpCost(rewnew.fuelSource)"><span
                                    id="opcost-{{rewnew.fuelSource}}" (click)="getOpCost(rewnew.fuelSource)"
                                    (blur)="onBlurOpCost(rewnew.fuelSource)"> {{rewnew.opCost}}</span></mat-grid-tile>
                            <mat-grid-tile style="background-color:#fff"
                                attr.contenteditable="{{newEmail == 'demo@ecomatrix.io'?'false':'true'}}"
                                (blur)="onBlurCarbonTax(rewnew.fuelSource)" (keydown)="getDefVal($event)"><span
                                    id="carbontax-{{rewnew.fuelSource}}" (click)="getCarbonCost(rewnew.fuelSource)"
                                    (blur)="onBlurCarbonTax(rewnew.fuelSource)">
                                    {{rewnew.carbonTax}}</span></mat-grid-tile>



                        </div>


                    </mat-grid-list>

                </div>
            </div> 
        </div> -->
        <!--end of row div -->
        <!-- <button (click)="clickMeBack()" class="backTop" mat-raised-button color="default">Back</button>
      <button (click)="clickMeBack()" class="back" mat-raised-button color="default">Back</button>
      <button (click)="clickMeForwar()" class="nextStepBot" mat-raised-button color="primary">Next Step</button>
      <button (click)="clickMeForwar()" class="nextStepTop" mat-raised-button color="primary">Next Step</button> -->

        <!-- <button (click)="goHome()" class="nextStepBotRenew" mat-raised-button color="primary"
            ng-disabled="isUpdated==true">Finish</button> -->
    </mat-tab>
</mat-tab-group>